export default function ({ store, redirect }) {
  // If the user is not authenticated
  if (!store.getters['user/getAuthenticated']) {
    return redirect('/clearance/login')
  }
}
